var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-home-content"},[_c('div',{staticClass:"action",on:{"click":_vm.backHome}},[_vm._v("\n    返回首页\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }